import React, { Suspense } from "react";
import { Await, defer, useLoaderData } from "react-router-dom";
import SystemMailCampaignEditor from "../../components/SystemMailCampaign/SystemMailCampaignEditor";
import { loadCustomerReceiverGroups } from "../Receiver/ReceiverManager";
import { getCustomerSystemMails } from "../../api/systemMailClient";
import { ReceiverGroup } from "../../model/ReceiverGroup";
import { SystemMailWithoutBody } from "../../model/SystemMail";
import { CircularProgress } from "@mui/material";

const NewSystemMailCampaignPage: React.FC = () => {
    const { receiverGroups, systemMailTemplates } = useLoaderData() as {
        receiverGroups: Promise<ReceiverGroup[]>;
        systemMailTemplates: Promise<SystemMailWithoutBody[]>;
    };

    return (
        <Suspense fallback={<CircularProgress />}>
            <Await resolve={Promise.all([receiverGroups, systemMailTemplates])}>
                {([receiverGroupsData, systemMailTemplatesData]) => (
                    <SystemMailCampaignEditor
                        method="POST"
                        receiverGroups={receiverGroupsData}
                        systemMailTemplates={systemMailTemplatesData}
                    />
                )}
            </Await>
        </Suspense>
    );
};

export default NewSystemMailCampaignPage;

async function loadSystemMailTemplates(customerId: string) {
    return getCustomerSystemMails(customerId);
}

export async function loader({
    params,
}: {
    request: Request;
    params: { customerId: string };
}) {
    const customerId = params.customerId;
    return defer({
        receiverGroups: loadCustomerReceiverGroups(customerId),
        systemMailTemplates: loadSystemMailTemplates(customerId),
    });
}
